export default "__VITE_ASSET__ByhgcDeG__"